import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiDefaultFetcher, apiPostFetcher } from '@/common/api/fetcher'
import {
  AnalyzeGscKeywordsResponse,
  AnalyzeGscKeywordsVars,
  AnalyzeGscSiteResponse,
  GetAuthUrlResponse,
  GscApiPath,
  GscStatusResponse,
  GscStatusVars,
  ListGscSitesResponse,
  ListGscSitesVars
} from '@/common/api/params/gsc'

export const useGscStatusApi = (vars: GscStatusVars | undefined) => {
  return useSWR<GscStatusResponse, Response, [string, GscStatusVars] | undefined>(
    vars ? [GscApiPath.GSC_STATUS, vars] : undefined
  )
}

export const useGscSitesApi = (vars: ListGscSitesVars | undefined) => {
  return useSWR<ListGscSitesResponse, Response, [string, ListGscSitesVars] | undefined>(
    vars ? [GscApiPath.LIST_GSC_SITES, vars] : undefined
  )
}

// OAuth認証URLを取得（ボタン押下時に呼ぶ）
export const fetchGscAuthUrl = (siteId: number) =>
  apiDefaultFetcher<GetAuthUrlResponse>([GscApiPath.GET_AUTH_URL, { site_id: siteId }])

// 連携解除
export const disconnectGsc = (siteId: number) =>
  apiDefaultFetcher<{ status: string }>([GscApiPath.DISCONNECT_GSC, { site_id: siteId }])

// GSC分析を実行（gsc_site_url / days はクエリパラメータ）
export const analyzeGscSite = (siteId: number, gscSiteUrl: string, days: number) => {
  const path =
    GscApiPath.ANALYZE_GSC_SITE.replace('{site_id}', String(siteId)) +
    `?gsc_site_url=${encodeURIComponent(gscSiteUrl)}&days=${days}`
  return apiPostFetcher<AnalyzeGscSiteResponse>(path)
}

// 入力キーワードに関連する実際の検索クエリ実績（GSC）のみを取得する（記事作成画面のキーワード選定用）
export const useAnalyzeGscKeywordsMutation = (options?: {
  onSuccess?: (response: AnalyzeGscKeywordsResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<AnalyzeGscKeywordsResponse, AnalyzeGscKeywordsVars>(
    GscApiPath.ANALYZE_GSC_KEYWORDS,
    { ...options },
    apiPostFetcher
  )
}
